import React from "react";
import { Steps, theme } from "antd";
import {
  FileTextOutlined,
  SyncOutlined,
  StarOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import { ITicket, TicketStatus } from "../../../Services/TicketServices";

interface TicketStepsProps {
  ticket: ITicket;
}

export const TicketSteps: React.FC<TicketStepsProps> = ({ ticket }) => {
  const { token } = theme.useToken();
  const subtleBorder = `1px solid ${token.colorBorderSecondary}`;

  const getActiveStep = (status: TicketStatus) => {
    if ([TicketStatus.Closed].includes(status)) return 2;
    if (
      [
        TicketStatus.InProgress,
        TicketStatus.UnderResearch,
        TicketStatus.InTesting,
        TicketStatus.ReadyForRelease,
      ].includes(status)
    ) {
      return 1;
    }
    return 0;
  };

  const getStatusText = (status: TicketStatus) => {
    switch (status) {
      case TicketStatus.Open: return "Open";
      case TicketStatus.Closed: return "Closed";
      case TicketStatus.InProgress: return "In progress";
      case TicketStatus.UnderResearch: return "Under research";
      case TicketStatus.InTesting: return "Testing";
      case TicketStatus.ReadyForRelease: return "Ready for release";
      default: return "Unknown";
    }
  };

  const activeStep = getActiveStep(ticket.status);

  return (
    <div
      style={{
        padding: "12px 24px",
        background: token.colorBgContainer,
        borderBottom: subtleBorder,
      }}
    >
      <Steps
        size="small"
        current={activeStep}
        style={{ margin: 0 }}
        items={[
          {
            title: <span style={{ fontSize: 12, fontWeight: 600 }}>Logged</span>,
            subTitle: (
              <span style={{ fontSize: 10, opacity: 0.85 }}>
                {dayjs(ticket.createdBy?.date).format("DD MMM")}
              </span>
            ),
            icon: <FileTextOutlined style={{ fontSize: 12 }} />,
          },
          {
            title: <span style={{ fontSize: 12, fontWeight: 600 }}>Investigation</span>,
            subTitle: (
              <span style={{ fontSize: 10, opacity: 0.85 }}>
                {activeStep === 1 ? (
                  getStatusText(ticket.status)
                ) : (
                  activeStep > 1 ? "Completed" : "Pending"
                )}
              </span>
            ),
            icon: (
              <SyncOutlined
                spin={[TicketStatus.InProgress, TicketStatus.InTesting, TicketStatus.ReadyForRelease, TicketStatus.UnderResearch].includes(ticket.status)}
                style={{ fontSize: 12 }}
              />
            ),
          },
          {
            title: <span style={{ fontSize: 12, fontWeight: 600 }}>Resolution</span>,
            subTitle: (
              <span style={{ fontSize: 10, opacity: 0.85 }}>
                {activeStep === 2 ? "Completed" : "Pending"}
              </span>
            ),
            icon: <StarOutlined style={{ fontSize: 12 }} />,
          },
        ]}
      />
    </div>
  );
};
